<template>
  <div id="newsingle">
    <div id="newtitle">新增商品</div>
    <div id="newbody">
      <div>

        <File :style="{width: '467px', height: '350px', minHeight: '350px'}" :folder="'product'"
        :defaultValue="item.image" @input="item.image=$event"/>

        <div class="field">
          <div ref="name">*商品名稱</div>
          <div>
            <input type="text" v-model="item.name">
          </div>
        </div>

        <div class="field">
          <div ref="name">商品名稱2</div>
          <div>
            <input type="text" v-model="item.name2">
          </div>
        </div>

        <div class="field" :style="{height: '-webkit-fill-available'}">
          <div>商品介紹</div>
          <div :style="{height: '-webkit-fill-available'}">
            <textarea v-model="item.description" :style="{height: '-webkit-fill-available'}"></textarea>
          </div>
        </div>

      </div>

      <div>
        <div class="field">
          <div ref="area">*區域</div>
          <div>
            <Checkbox :options="restaurants" :color="'var(--color-pri)'" :defaultValue="item.area" @input="item.area=$event"/>
          </div>
        </div>
        <div class="field">
          <div>商品編號</div>
          <div>
            <input type="text" v-model="item.id" :style="{width: '180px'}">
          </div>
        </div>
        <div class="field">
          <div ref="type">*商品用途</div>
          <div>
            <Select :width="'166px'" :defaultValue="item.type" @input="item.type=$event">
            <option v-for="(usage, u) in usages" :key="`usages-${u}`" :value="usage">{{usage}}</option></Select>
          </div>
        </div>

        <div class="field">
          <div ref="category">*商品類別</div>
          <div>
            <Select :width="'290px'" :defaultValue="item.category" @input="item.category=$event">
              <option :value="null">請選擇類別</option>
              <option v-for="(type, t) in types" :key="t" :value="type">{{type}}</option>
            </Select>
          </div>
        </div>

        <div class="field">
          <div ref="unit">*販售單位</div>
          <div>
            <input type="text" :style="{width: '84px'}" v-model="item.unit">
          </div>
        </div>

        <div class="field">
          <div ref="price">*商品售價</div>
          <div>
            <input type="text" v-model="item.price">
          </div>
        </div>
      </div>
    </div>
    <Btns :align="'center'" :style="{display: 'flex', flexDirection: 'row', margin: 'auto'}"
    @cancel="clean" @save="save"/>
  </div>
</template>

<script>
import Btns from '../../../../components/btn/btns.vue'
import { mapState } from 'vuex'
import Select from '../../../../components/select.vue'
import File from '../../../../components/input/file2.vue'
import { putapi } from '../../../../store/fetch'
import Checkbox from '../../../../components/checkbox/checkbox.vue'
export default {
  props: ['types'],
  components: {
    File,
    Select,
    Btns,
    Checkbox
  },
  computed: {
    ...mapState({
      restaurants: 'restaurants',
      usages: 'usages'
    })
  },
  data () {
    return {
      area: [],
      type: null,
      item: {
        id: null,
        name: null,
        name2: null,
        image: null,
        area: [],
        type: null,
        category: null,
        unit: '份',
        price: 0,
        description: null
      }
    }
  },
  watch: {
    'item.name' () {
      this.$refs.name.style.color = 'var(--color-pri)'
    },
    'item.category' () {
      this.$refs.category.style.color = 'var(--color-pri)'
    },
    'item.type' () {
      this.$refs.type.style.color = 'var(--color-pri)'
    },
    'item.price' () {
      this.$refs.price.style.color = 'var(--color-pri)'
    },
    'item.unit' () {
      this.$refs.unit.style.color = 'var(--color-pri)'
    },
    'item.area' () {
      this.$refs.area.style.color = 'var(--color-pri)'
    }
  },
  methods: {
    clean () {
      this.item = {
        name: null,
        name2: null,
        image: null,
        area: [],
        type: null,
        category: null,
        unit: '份',
        price: 0,
        description: null
      }
    },
    async save () {
      if (!this.item.name) {
        this.$refs.name.style.color = 'red'
        this.$refs.name.scrollIntoView()
        return false
      }
      if (!this.item.area || this.item.area.length === 0) {
        this.$refs.area.style.color = 'red'
        this.$refs.area.scrollIntoView()
        return false
      }
      if (!this.item.type) {
        this.$refs.type.style.color = 'red'
        this.$refs.type.scrollIntoView()
        return false
      }
      if (!this.item.category) {
        this.$refs.category.style.color = 'red'
        this.$refs.category.scrollIntoView()
        return false
      }
      if (!this.item.unit) {
        this.$refs.unit.style.color = 'red'
        this.$refs.unit.scrollIntoView()
        return false
      }
      if (this.item.price === null || isNaN(parseInt(this.item.price))) {
        this.$refs.price.style.color = 'red'
        this.$refs.price.scrollIntoView()
        return false
      }
      const r = await putapi('rest_product/single', { ...this.item })
      if (r) {
        this.$emit('new', r)
        this.clean()
      }
    }
  }
}
</script>
<style lang="scss">
#mewbody {
  label,  .fileInput {
    background-color: transparent;
  }
  .fileInput > label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 467px!important;
    height: 350px!important;
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: -webkit-fill-available;
  &>div:nth-child(1) {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-pri);
    margin-left: -0.5em;
  }
  &>div:nth-child(2) {
    flex:1;
    width: -webkit-fill-available;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
  input[type=text], textarea {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    height: 45px;
    width: 100%;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    /* identical to box height */
    letter-spacing: 0.1em;
    padding-inline: .5em;
  }
  input[type=text] {
    height: 45px;
  }
  textarea {
    height: 165px;
    width: -webkit-fill-available;
    flex: 1;
  }
}
#newsingle {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 21px 60px 21px 67px;
  gap: 25px;
}
#newtitle {
  font-weight: 500;
  font-size: 28px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--color-pri);
}
#newbody {
  flex:1;
  display: grid;
  grid-template-columns: 467px 290px;
  gap: 69px;
  flex-direction: rows;
  flex-wrap: wrap;
  &>div{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;

  }
}
</style>
